var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.flatSeries.length)?_c('ApexChart',{class:{
    'with-links': !!_vm.result.links
  },attrs:{"options":_vm.chartOptions,"height":"400","series":_vm.series}}):_c('div',{staticClass:"text-center",staticStyle:{"margin":"7em 0"}},[_c('v-icon',{attrs:{"size":"96"}},[_vm._v("multiline_chart")]),_c('br'),_c('br'),_c('h1',{staticClass:"headline"},[_vm._v("Sin Datos")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }